var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWfArrowCollapsed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9px",
    height: "15px",
    viewBox: "0 0 9 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.376165801,2.29977682 L4.94730303,7.0598822 L0.376165801,11.8185761 C-0.1253886,12.3450459 -0.1253886,13.1968542 0.376165801,13.723324 C0.883098802,14.2490881 1.70199057,14.2490881 2.20892357,13.723324 L7.69106109,8.01119756 C8.19261549,7.48472778 8.19261549,6.63221373 7.69106109,6.1071554 L2.20892357,0.394323215 C1.70199057,-0.132146558 0.883098802,-0.130735111 0.376165801,0.394323215 C-0.1253886,0.921498711 -0.1253886,1.77330704 0.376165801,2.29977682 Z",
    id: "Path",
    fill: "#BEC8D2",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWfArrowCollapsed);
export default __webpack_public_path__ + "static/media/wf_arrow_collapsed.408fa43d3f7bbc6ee3f8d1b97bbe1d72.svg";
export { ForwardRef as ReactComponent };